import { getUserDisplayName, useUser } from '$logic/users'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'
import { WithQueryTitleBase } from '../with-query-title-base'

export function WithQueryUserListItemTitle({
  userId,
  query,
}: {
  userId?: string
  query: string
}) {
  const { user } = useUser(userId)
  const title = getUserDisplayName(user)

  return (
    <WithQueryTitleWrapper>
      <WithQueryTitleBase query={query} title={title} variant="subtitle3" />
    </WithQueryTitleWrapper>
  )
}
